import React, { useRef } from 'react';
import { Message } from 'talkplus-sdk/dist/model/types';
import ChatInput from '@components/chat/chatDetail/chatInput';
import MessageList from '@components/chat/chatDetail/messageList';
import useScroll from '@components/chat/hooks/useScroll';
import NoticeToast from '@components/chat/chatDetail/noticeToast';
import useChatReply from '@components/chat/hooks/useChatReply';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const ChatDetail = () => {
  const textAreaRef = useRef<HTMLTextAreaElement | null>(null);
  const useScrollProps = useScroll();
  const { parentMessage, setParentMessage } = useChatReply();

  const handleFocus = () => {
    const el = textAreaRef?.current;
    if (!el) return;
    el.focus();
  };

  const handleReply = (message: Message) => {
    if (parentMessage) return handleCloseReply();
    handleFocus();
    setParentMessage(message);
  };

  const handleCloseReply = () => {
    handleFocus();
    setParentMessage(null);
  };

  return (
    <div className={cx('detailArea')}>
      <MessageList useScrollProps={useScrollProps} handleReply={handleReply} isReplying={!!parentMessage} />
      <ChatInput
        useScrollProps={useScrollProps}
        textAreaRef={textAreaRef}
        parentMessage={parentMessage}
        handleCloseReply={handleCloseReply}
      />
      <NoticeToast />
    </div>
  );
};

export default ChatDetail;
